import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Jel extends Product {
  @belongsTo('station-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'jel';
  label = 'JEL';
}

export default Jel;
